import { useState } from "react";
import { toast } from "sonner";
import axios from "../axios";

export const useGetAllCampaigns = () => {
  const [loading, setLoading] = useState(false);
  const [campaigns, setCampaigns] = useState([]);

  const getCampaigns = async (token, filter, category) => {
    setLoading(true);
    try {
      const res = await axios.get(
        `/audiences/campaign?filter=${filter}&category=${category}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (res.status === 201) {
        setLoading(false);
        setCampaigns(res?.data?.data);
      }
    } catch (err) {
      setLoading(false);
      toast.error(err?.response?.data?.message);
    }
  };

  return { getCampaigns, campaigns, setCampaigns, loading, setLoading };
};
